import React, { useEffect, useState } from "react";
import {
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  IconButton,
  FormHelperText,
  styled,
  OutlinedInput,
  Autocomplete,
  Box,
} from "@mui/material";
import { useSnackbar } from "notistack";
import PhoneInput from "react-phone-number-validation";
import FormInput from "../../components/GeneralComponents/FormInput";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useAdminContext } from "../../Hooks/AdminContext";
import BasicBreadcrumbs from "../../components/GeneralComponents/BreadCrumbs";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { countries, uploadImage } from "../../utils/constant";
import { isValidPhoneNumber } from "libphonenumber-js";
import {
  _Add_Customer,
  _Get_Customer_ById,
  _Update_Customer,
} from "../../DAL/Listing/UserListing";
import CustomCircularProgress from "../../components/CustomCircularProgress";
import { picBaseUrl } from "../../config/config";

const Input = styled("input")({
  display: "none",
});

export const AddOrUpdateUser = ({ type }) => {
  const [loading, setLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const { setnavbarTitle } = useAdminContext();

  let isValid = phoneNumber === "" || isValidPhoneNumber(phoneNumber);

  const handlePhoneChange = (value, country) => {
    // console.log("Phone Number:", value);
    // console.log("Selected Country:", country);
    setPhoneNumber(value);
  };
  const [file, setProfileImage] = useState();
  const params = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [localInput, setLocalInput] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    phone: "",
    company_name: "",
    street_address: "",
    city: "",
    state: "",
    country: null,
    postal_code: "",
    image: "",
    status: true,
    topup_fee: "",
    affiliate_commission: "",
  });

  const { enqueueSnackbar } = useSnackbar();

  const handleChange = (e, name) => {
    setLocalInput({ ...localInput, [name]: e.target.value });
  };
  const handleCountryChange = (value) => {
    setLocalInput({ ...localInput, country: value });
  };
  const [selectedAddress1, setSelectedAddress1] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const fileChangedHandler = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    // Allowed image types
    const allowedTypes = ["image/jpeg", "image/png", "image/webp"];
    if (!allowedTypes.includes(file.type)) {
      enqueueSnackbar("Only JPG, JPEG, PNG, and WEBP files are allowed.", {
        variant: "error",
      });
      return;
    }

    // If valid, update state
    setProfileImage(URL.createObjectURL(file));
    setLocalInput({
      ...localInput,
      ["image"]: file,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isValid) {
      enqueueSnackbar("Please enter a valid phone number", {
        variant: "error",
      });
      return;
    }
    if (!params.id) {
      if (localInput.password.length < 8) {
        enqueueSnackbar("Password should be at least 8 characters long", {
          variant: "error",
        });
        return;
      }
    }

    setLoading(true);
    let imagePath = localInput.image;

    if (localInput.image && typeof localInput.image !== "string") {
      const uploadedPath = await uploadImage(localInput.image);
      if (!uploadedPath) {
        setLoading(false);
        return; // Stop execution if upload fails
      }
      imagePath = uploadedPath;
    }

    const formData = {
      first_name: localInput.first_name,
      last_name: localInput.last_name,
      email: localInput.email,
      password: localInput.password,
      contact_number: phoneNumber,
      profile_image: imagePath,
      status: localInput.status,
      company_name: localInput.company_name,
      street: localInput.street_address,
      city: localInput.city,
      state: localInput.state,
      postal_code: localInput.postal_code,
      country: localInput.country,
      topup_fee: localInput.topup_fee,
      affiliate_commission: localInput.affiliate_commission,
    };

    if (params.id) {
      delete formData.password;
    }
    if (!params.id) {
      delete formData.topup_fee;
      delete formData.affiliate_commission;
    }
    // console.log(params.id, "params.idparams.idparams.id");
    const response =
      type === "add"
        ? await _Add_Customer(formData)
        : await _Update_Customer(formData, params.id);

    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      setLoading(false);
      navigate("/user-management");
    } else {
      setLoading(false);
      enqueueSnackbar(response.message, { variant: "error" });
    }
  };

  const BreadCrumbsList = [
    {
      title: "User Management",
      navigation: "/user-management",
      active: false,
    },
    {
      title: `${params.id ? "Edit" : "Add"} User`,
      navigation: "",
      status: "Active",
    },
  ];

  const GetUser = async () => {
    setLoading(true);
    const response = await _Get_Customer_ById(params.id);
    if (response.code === 200) {
      setLocalInput({
        ...response.customer,
        email: response?.customer?.user_id?.email,
        country: response?.customer?.country,
        street_address: response?.customer?.street,
        image: response?.customer?.profile_image,
      });
      setPhoneNumber(response?.customer?.contact_number);
      setLoading(false);
    } else {
      setLoading(false);
      enqueueSnackbar(response.message, { variant: "error" });
    }
  };

  useEffect(() => {
    if (state) {
      setLocalInput({
        ...state,
        email: state.user_id.email,
        country: state.country,
        street_address: state.street,
        image: state?.profile_image,
      });
      setPhoneNumber(state.contact_number);
    } else if (params.id && !state) {
      GetUser();
    }
    setnavbarTitle("User Management");
  }, [state]);

  // console.log(state, "state statestatestate");

  if (loading) {
    return <CustomCircularProgress />;
  }
  return (
    <div className="container-fluid">
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-12 mb-3">
            <BasicBreadcrumbs items={BreadCrumbsList} />
          </div>
          <div className="col-md-6">
            <FormInput
              fullWidth
              label="First Name"
              variant="outlined"
              value={localInput.first_name}
              onChange={(e) => handleChange(e, "first_name")}
              required
            />
          </div>
          <div className="col-md-6">
            <FormInput
              fullWidth
              label="Last Name"
              variant="outlined"
              value={localInput.last_name}
              onChange={(e) => handleChange(e, "last_name")}
              required
            />
          </div>
          <div className="col-md-6 mt-2">
            <FormInput
              fullWidth
              label="Company Name"
              variant="outlined"
              value={localInput?.company_name}
              onChange={(e) => handleChange(e, "company_name")}
              required
            />
          </div>
          <div className="col-md-6 mt-2">
            <FormInput
              fullWidth
              type="email"
              label="Email"
              variant="outlined"
              value={localInput.email}
              onChange={(e) => handleChange(e, "email")}
              required
            />
          </div>

          {!params.id && (
            <div className="col-md-6 mt-3">
              <TextField
                fullWidth
                label="Password"
                variant="outlined"
                value={localInput.password}
                onChange={(e) => handleChange(e, "password")}
                type={showPassword ? "text" : "password"}
                required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={togglePasswordVisibility} edge="end">
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          )}
          <div className="col-md-6 mt-3">
            <PhoneInput
              enableSearch={true}
              autoSelectCountry={true}
              countryCodeEditable={false}
              country="pk"
              value={phoneNumber}
              setValue={setPhoneNumber}
              onChange={handlePhoneChange}
              onRender={(value, country) => {
                setPhoneNumber(value);
              }}
            />
          </div>
          <div className="col-md-6 mt-3">
            <FormControl fullWidth required>
              <InputLabel>Status</InputLabel>
              <Select
                value={localInput?.status}
                onChange={(e) => handleChange(e, "status")}
                label="Status"
              >
                <MenuItem value={true}>Active</MenuItem>
                <MenuItem value={false}>Inactive</MenuItem>
              </Select>
            </FormControl>
          </div>
          {/* {params.id && (
            <div className="col-md-6 mt-3">
              <FormControl fullWidth required>
                <InputLabel htmlFor="topup_fee">Top Up Fee</InputLabel>
                <OutlinedInput
                  id="topup_fee"
                  value={localInput?.topup_fee}
                  type="number"
                  onChange={(e) => {
                    let value = Math.min(
                      100,
                      Math.max(0, Number(e.target.value))
                    );
                    handleChange(
                      { target: { name: "topup_fee", value } },
                      "topup_fee"
                    );
                  }}
                  name="topup_fee"
                  endAdornment={
                    <InputAdornment position="end">%</InputAdornment>
                  }
                  label="Top Up Fee"
                />
              </FormControl>
            </div>
          )} */}

          {params.id && (
            <div className="col-md-6 mt-3">
              <FormControl fullWidth required>
                <InputLabel htmlFor="affiliate-commission">
                  Affiliate Commission
                </InputLabel>
                <OutlinedInput
                  id="affiliate-commission"
                  value={localInput?.affiliate_commission}
                  type="number"
                  onChange={(e) => {
                    let value = Math.min(
                      100,
                      Math.max(0, Number(e.target.value))
                    ); // Ensures value is between 0 and 100
                    handleChange(
                      { target: { name: "affiliate_commission", value } },
                      "affiliate_commission"
                    );
                  }}
                  name="affiliate_commission"
                  endAdornment={
                    <InputAdornment position="end">%</InputAdornment>
                  }
                  label="Affiliate Commission"
                />
              </FormControl>
            </div>
          )}

          <div className="col-lg-12 col-md-12 col-sm-12 mt-4">
            <div className="row w-100 div-style ms-0 pt-0">
              <div className="col-lg-5 col-md-5 col-sm-12">
                <p className="">Upload Image</p>
                <FormHelperText className="pt-0 text-muted">
                  Image Size(500 X 500) ("JPG", "JPEG", "PNG","WEBP")
                </FormHelperText>
              </div>
              <div className="col-lg-2 col-md-2 col-6">
                {file ? (
                  <img className="image-border" src={file} height="50" />
                ) : (
                  <>
                    {localInput.image && (
                      <img
                        className="image-border"
                        src={picBaseUrl + localInput.image}
                        height="50"
                      />
                    )}
                  </>
                )}
              </div>
              <div className="col-lg-5 col-md-5 col-6 text-end pt-2">
                <label htmlFor="contained-button-file">
                  <Input
                    accept="image/*"
                    id="contained-button-file"
                    multiple
                    type="file"
                    name="image"
                    onChange={fileChangedHandler}
                  />

                  <Button
                    className="small-contained-button"
                    startIcon={
                      <FileUploadIcon
                        style={{
                          fill: "#fff",
                        }}
                      />
                    }
                    component="span"
                  >
                    Upload
                  </Button>
                </label>
              </div>
            </div>
            {localInput?.image?.name && (
              <p className="text-secondary mb-0">{localInput?.image?.name}</p>
            )}
          </div>
          <div className="col-md-6 mt-3">
            <FormInput
              fullWidth
              label="Street Address"
              variant="outlined"
              value={localInput?.street_address}
              onChange={(e) => handleChange(e, "street_address")}
              required
            />
          </div>
          <div className="col-md-6 mt-3">
            <FormInput
              fullWidth
              label="City"
              variant="outlined"
              value={localInput?.city}
              onChange={(e) => handleChange(e, "city")}
              required
            />
          </div>
          <div className="col-md-6 mt-2">
            <FormInput
              fullWidth
              label="State/Province"
              variant="outlined"
              value={localInput?.state}
              onChange={(e) => handleChange(e, "state")}
              required
            />
          </div>
          <div className="col-md-6 mt-2">
            <FormInput
              fullWidth
              label="Postal Code"
              variant="outlined"
              type="number"
              value={localInput?.postal_code}
              onChange={(e) => handleChange(e, "postal_code")}
              required
            />
          </div>
          <div className="col-md-6 mt-3">
            <Autocomplete
              id="country-select-demo"
              options={countries}
              autoHighlight
              value={localInput.country || null}
              onChange={(event, value) => handleCountryChange(value)}
              getOptionLabel={(option) => option?.label || ""}
              isOptionEqualToValue={(option, value) =>
                option.code === value?.code
              }
              renderOption={(props, option) => (
                <Box
                  component="li"
                  sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                  {...props}
                >
                  <img
                    loading="lazy"
                    width="20"
                    srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                    src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                    alt=""
                  />
                  {option.label}
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Choose a country"
                  required
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: "new-password",
                  }}
                />
              )}
            />
          </div>

          <div className="col-md-12 mt-3 text-end">
            <Button
              variant="contained"
              type="submit"
              disabled={loading}
              className="small-contained-button"
            >
              {params.id ? "Update" : "Submit"}
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};
